"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPBGeometryBackendResponseError = exports.isPBUnsupportedGrantTypeClientOAuthResponseError = exports.isPBUnauthorizedClientOAuthResponseError = exports.isPBInvalidGrantOAuthResponseError = exports.isPBInvalidClientOAuthResponseError = exports.isPBInvalidRequestOAuthResponseError = exports.isPBOAuthResponseError = exports.isPBValidationResponseError = exports.isPBUnauthorizedResponseError = exports.isPBForbiddenResponseError = exports.isPBNotFoundResponseError = exports.isPBResourceResponseError = exports.isPBServerResponseError = exports.isPBResponseError = exports.isPBRequestError = exports.isPBGenericError = exports.isPBError = void 0;
const SdPlatformErrors_1 = require("./SdPlatformErrors");
/** Type guard for all error types of the Geometry Backend SDK package. */
function isPBError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        Object.values(SdPlatformErrors_1.ShapeDiverErrorType).includes(e.errorType);
}
exports.isPBError = isPBError;
/** Type guard for a Platform Backend SDK generic error. */
function isPBGenericError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.Generic;
}
exports.isPBGenericError = isPBGenericError;
/** Type guard for a Platform Backend SDK request error. */
function isPBRequestError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.Request;
}
exports.isPBRequestError = isPBRequestError;
/** Type guard for a Platform Backend SDK response error. */
function isPBResponseError(e) {
    const errorTypes = [
        SdPlatformErrors_1.ShapeDiverErrorType.Response,
        SdPlatformErrors_1.ShapeDiverErrorType.ServerResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.ResourceResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.NotFoundResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.ForbiddenResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.UnauthorizedResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.ValidationResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.OAuthResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.InvalidRequestOAuthResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.InvalidClientOAuthResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.InvalidGrantOAuthResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.UnauthorizedClientOAuthResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.UnsupportedGrantTypeClientOAuthResponse,
        SdPlatformErrors_1.ShapeDiverErrorType.GeometryBackendResponse,
    ];
    return e instanceof Error &&
        "errorType" in e &&
        errorTypes.includes(e.errorType);
}
exports.isPBResponseError = isPBResponseError;
/**
 * Type guard for a Platform Backend SDK server response error.
 */
function isPBServerResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.ServerResponse;
}
exports.isPBServerResponseError = isPBServerResponseError;
/**
 * Type guard for a Platform Backend SDK resource response error.
 */
function isPBResourceResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.ResourceResponse;
}
exports.isPBResourceResponseError = isPBResourceResponseError;
/**
 * Type guard for a Platform Backend SDK not found response error.
 */
function isPBNotFoundResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.NotFoundResponse;
}
exports.isPBNotFoundResponseError = isPBNotFoundResponseError;
/**
 * Type guard for a Platform Backend SDK forbidden response error.
 */
function isPBForbiddenResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.ForbiddenResponse;
}
exports.isPBForbiddenResponseError = isPBForbiddenResponseError;
/**
 * Type guard for a Platform Backend SDK unauthorized response error.
 */
function isPBUnauthorizedResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.UnauthorizedResponse;
}
exports.isPBUnauthorizedResponseError = isPBUnauthorizedResponseError;
/**
 * Type guard for a Platform Backend SDK validation response error.
 */
function isPBValidationResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.ValidationResponse;
}
exports.isPBValidationResponseError = isPBValidationResponseError;
/**
 * Type guard for a Platform Backend SDK OAuth response error.
 */
function isPBOAuthResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.OAuthResponse;
}
exports.isPBOAuthResponseError = isPBOAuthResponseError;
/**
 * Type guard for a Platform Backend SDK invalid request OAuth response error.
 */
function isPBInvalidRequestOAuthResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.InvalidRequestOAuthResponse;
}
exports.isPBInvalidRequestOAuthResponseError = isPBInvalidRequestOAuthResponseError;
/**
 * Type guard for a Platform Backend SDK invalid client OAuth response error.
 */
function isPBInvalidClientOAuthResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.InvalidClientOAuthResponse;
}
exports.isPBInvalidClientOAuthResponseError = isPBInvalidClientOAuthResponseError;
/**
 * Type guard for a Platform Backend SDK invalid grant OAuth response error.
 */
function isPBInvalidGrantOAuthResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.InvalidGrantOAuthResponse;
}
exports.isPBInvalidGrantOAuthResponseError = isPBInvalidGrantOAuthResponseError;
/**
 * Type guard for a Platform Backend SDK unauthorized client OAuth response error.
 */
function isPBUnauthorizedClientOAuthResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.UnauthorizedClientOAuthResponse;
}
exports.isPBUnauthorizedClientOAuthResponseError = isPBUnauthorizedClientOAuthResponseError;
/**
 * Type guard for a Platform Backend SDK unsupported grant type client OAuth response error.
 */
function isPBUnsupportedGrantTypeClientOAuthResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.UnsupportedGrantTypeClientOAuthResponse;
}
exports.isPBUnsupportedGrantTypeClientOAuthResponseError = isPBUnsupportedGrantTypeClientOAuthResponseError;
/**
 * Type guard for a Platform Backend SDK Geometry Backend response error.
 */
function isPBGeometryBackendResponseError(e) {
    return e instanceof Error &&
        "errorType" in e &&
        e.errorType === SdPlatformErrors_1.ShapeDiverErrorType.GeometryBackendResponse;
}
exports.isPBGeometryBackendResponseError = isPBGeometryBackendResponseError;
//# sourceMappingURL=SdPlatformErrorTypeGuards.js.map